// phone-validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';

const MIN_LEN: Partial<Record<TuiCountryIsoCode, number>> = {
  [TuiCountryIsoCode.DE]: 10,
  [TuiCountryIsoCode.AD]: 6,
  [TuiCountryIsoCode.ES]: 9,
  [TuiCountryIsoCode.GB]: 10,
  [TuiCountryIsoCode.FR]: 9,
  [TuiCountryIsoCode.IT]: 10,
  [TuiCountryIsoCode.PT]: 9,
  [TuiCountryIsoCode.NL]: 9,
  [TuiCountryIsoCode.CL]: 9,
  [TuiCountryIsoCode.DO]: 10,
};

/**
 * Crea un validador que toma el ISO-country desde otro control
 * del mismo `FormGroup` (por ejemplo  `<campo>Iso`).
 *
 * @param isoCtrlName nombre del FormControl que guarda el ISO
 */
export function phoneValidatorV2(isoCtrlName: string): ValidatorFn {
  return (ctrl: AbstractControl): ValidationErrors | null => {
    const raw = (ctrl.value || '').toString().trim();
    if (!raw) {
      return null; 
    }

    const group = ctrl.parent;
    if (!group) {
      return { invalidFormat: true };
    }

    const iso: TuiCountryIsoCode = group.get(isoCtrlName)?.value;
    if (!iso) {
      return null;
    }

    const cleaned = raw.replace(/[^\d+]/g, '');
    let phone: PhoneNumber | undefined;
    try {
      phone = parsePhoneNumberFromString(cleaned, iso);
      if (!phone) {
        return { invalidFormat: true };
      }
    } catch {
      return { invalidFormat: true };
    }

    if (!phone.isPossible() || !phone.isValid()) {
      return { invalidFormat: true };
    }

    const national = phone.nationalNumber;
    const min = MIN_LEN[iso] ?? 9;
    if (national.length < min) {
      return { tooShort: { min } };
    }
    return null;
  };
}
